import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_BASE_URL;

function buildQuery(params = {}) {
  const filtered = Object.entries(params).filter(
    ([, value]) => value !== undefined && value !== null && value !== ""
  );
  if (!filtered.length) {
    return "";
  }
  return `?${new URLSearchParams(Object.fromEntries(filtered)).toString()}`;
}

export default {
  getSeller(token) {
    return axios.get(`${API_URL}/store/${encodeURIComponent(token)}/seller`);
  },
  getProducts(token, params = {}) {
    return axios.get(
      `${API_URL}/store/${encodeURIComponent(token)}/products${buildQuery(params)}`
    );
  },
  getFilters(token) {
    return axios.get(`${API_URL}/store/${encodeURIComponent(token)}/filters`);
  },
  createCotizacion(token, payload) {
    return axios.post(
      `${API_URL}/store/${encodeURIComponent(token)}/cotizaciones`,
      payload
    );
  },
  getMyLink() {
    return axios.get(`${API_URL}/store/my-link`, { headers: authHeader() });
  },
};
